import { useEffect, useMemo } from "react";
import other from "./other";
import { IconHelp, IconJumpRope } from "@tabler/icons";
import { useDispatch, useSelector } from "../store";
import {
  toggleAddEditFolder,
  fetchFolders,
  selectFolders,
} from "../store/slices/menu";
import useAuth from "../hooks/useAuth";

import { ReactComponent as IconFolderCog } from "@src/assets/images/folder-cog.svg";

// permission_flags bit 3 (1 << 3) === Nabuz super admin
const NABUZ_SUPER_ADMIN_FLAG = 1 << 3;

export const useMenuItems = () => {
  const dispatch = useDispatch();
  const folders = useSelector((state) => selectFolders(state));
  const { user } = useAuth();
  const isSuperAdmin =
    ((user?.permission_flags ?? 0) & NABUZ_SUPER_ADMIN_FLAG) !== 0;

  const menuItems = useMemo(() => {
    return {
      items: [
        {
          ...other,
          // The Admins panel is super-admin only.
          children: other.children
            .filter((child) => child.id !== "admins" || isSuperAdmin)
            .map((child) => {
            if (child.id === "exercises") {
              return {
                ...child,
                type: "collapse",
                children: [
                  {
                    id: "all-exercises",
                    title: "All Exercises",
                    type: "item",
                    url: "/exercise",
                    icon: IconJumpRope,
                    breadcrumbs: false,
                  },
                  ...folders,
                  {
                    id: "add-root-folder",
                    title: "Add New Folder",
                    type: "item",
                    url: "",
                    icon: IconHelp,
                    breadcrumbs: false,
                    sx: { pl: 2 },
                    onPress: () => dispatch(toggleAddEditFolder(true)),
                  },
                  {
                    id: "manage-folders",
                    title: "Manage Folders",
                    type: "item",
                    url: "/exercise/folders",
                    icon: () => (
                      <IconFolderCog color={"inherit"} width={20} height={20} />
                    ),
                    breadcrumbs: false,
                    sx: { pl: 2 },
                  },
                ],
              };
            }
            return child;
          }),
        },
      ],
    };
    
  }, [folders, isSuperAdmin]);

  useEffect(() => {
    dispatch(fetchFolders());
  }, []);

  return menuItems;
};

const menuItems = {
  items: [other],
};

export default menuItems;
